import { FaPlus } from 'react-icons/fa6';

import { MaintenanceTaskCard } from '@/components/Widget/MaintenanceWidget/MaintenanceTaskCard';
import { TaskStatus, type TaskResponse, TODO_DONE_STATUSES } from '@/store/tasks/tasks.dto';

import s from './TasksSection.module.scss';

interface TasksSectionProps {
  tasks: TaskResponse[];
  isServiceProvider?: boolean;
  showAddTask?: boolean;
  onAddTaskClick?: () => void;
  onTaskStatusChange?: (taskId: string, serviceId: string, status: TaskStatus) => void;
  onEdit?: (taskId: string) => void;
  onDelete?: (taskId: string) => void;
}

export function TasksSection({
  tasks,
  isServiceProvider,
  showAddTask,
  onAddTaskClick,
  onTaskStatusChange,
  onEdit,
  onDelete,
}: TasksSectionProps) {
  return (
    <div className={s.tasksSection}>
      {tasks.length === 0 ? (
        <p className={s.emptyState}>Please add a task to get started.</p>
      ) : (
        <div className={s.tasksList}>
          {tasks.map((task) => (
            <MaintenanceTaskCard
              key={task.id}
              task={task}
              isServiceProvider={isServiceProvider}
              /* An event's task is outstanding or finished, the same two states the
                 tasks and maintenance lists run on. Owner's view only: the provider's
                 own statuses are disjoint from To do / Done. */
              statusOptions={isServiceProvider ? undefined : TODO_DONE_STATUSES}
              onTaskStatusChange={onTaskStatusChange}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          ))}
        </div>
      )}
      {showAddTask && (
        <div className={s.tasksActions}>
          <button type="button" className={s.addTaskButton} onClick={onAddTaskClick}>
            <span className={s.addIcon}>
              <FaPlus />
            </span>
            Add Task
          </button>
        </div>
      )}
    </div>
  );
}
